import { render } from "./OdontogramForm.vue?vue&type=template&id=0ae95887"
import script from "./OdontogramForm.vue?vue&type=script&lang=js"
export * from "./OdontogramForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__